import * as React from "react";

interface IProfessionalItemProps {
    professional: any
    index: number
    select?: Function
}

interface IProfessionalItemState{

}


export default class ProfessionalItem extends React.Component<IProfessionalItemProps, IProfessionalItemState> {

    constructor(props: IProfessionalItemProps) {
        super(props);
        this.state = {};

    }


    render() {
        let item = this.props.professional;
        return (
            <div key={'offer_list_'+this.props.index} className="row no-gutters" onClick={() => this.props.select(item)}>
                <div className="item_row" id={'offer_row_'+item.id}>
                    <div className="item_content">
                        <div className="left">
                            <img src = {item.offerType.img}/>
                        </div>
                        <div className="right">
                            <div className="m-left">
                                <p className = "service-name">{ item.offerType.name }</p>
                                <span className = "time">
                                    is available at the earliest:<br/>
                                    {item.freeDate}
                                </span>
                                <p className = "price">
                                    { item.price } { item.currency }/hour
                                </p>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
